import { createContext } from 'react';
import { UserInfoContextType } from '../types/UserInfos';

export const USER_INFO_QUERY_KEY = ['userInfo'] as const;

export const UserInfoContext = createContext<UserInfoContextType | undefined>(undefined);
